import React from "react";
import { Form, InputNumber, Button, Popconfirm } from "antd";
import _ from "lodash";
import ItemFormHelper from "./../itemForm/ItemFormHelper";
import CKEditor from 'ckeditor4-react';

const FormItem = Form.Item;

class ContentSection extends React.Component {

    constructor() {
        super();
        this.state = {
            contentObj: { sortNo: [], content: [], fields: [] }
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { editFormContents } = this.props;
        
        if (!_.isEqual(prevProps.editFormContents, editFormContents)) {
            if (editFormContents?.length) {
                const sortNo = [], content = [], fields = [];

                const formattedAdData = editFormContents?.map((contentObj) => {
                    if (contentObj?.type == "html") {
                        sortNo.push(contentObj?.sort);
                        content.push(contentObj?.content);
                        fields.push("");
                    }
                });

                this.setState({
                    contentObj: { sortNo, content, fields }
                });
            }
        }
    }

    _renderAd = (i) => {
        const addSortNo = (value) => {
            this.setState((prev) => {
                prev.contentObj.sortNo[i] = value;
                return {
                    contentObj: prev.contentObj
                };
            });
        };

        const onChange = (evt) => {
            const newContent = evt.editor.getData();
            this.setState((prev) => {
                prev.contentObj.content[i] = newContent;
                return {
                    contentObj: prev.contentObj
                };
            });
        }

        return (
          <div className="ant-row" key={"Ad_" + i}>
            <div className="ant-col-md-8">
              <InputNumber
                required
                placeholder="Sort No"
                onChange={addSortNo}
                value={this.state.contentObj.sortNo[i]}
              />
            </div>

            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-20">
                <FormItem
                  labelAlign="left"
                  label={
                    <span>
                      <span style={{ color: "red" }}>*</span>Content
                    </span>
                  }
                >
                  <CKEditor
                    activeClass="p10"
                    data={this.state.contentObj.content[i]}
                    config={{
                      //allowedContent: 'p b i s li ul ol h1 h2 bulletedList numberedlist',
                      extraPlugins: "colorbutton",
                      removePlugins:
                        "horizontalrule,blockquote,sourcearea,pasteFromWord",
                      removeButtons:
                        "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                    }}
                    onChange={onChange}
                  />
                </FormItem>
              </div>
              <div className="ant-col-md-4 rite-btn">
                <div className="action-btn">
                  <a href="" title="Delete">
                    <Popconfirm
                      title="Are you sure delete this ?"
                      onConfirm={() => {
                        this.setState((prev) => {
                          // Services.removeBanner(this.state.ad._id[i])
                          // delete prev.contentObj?.fields[i];
                          prev.contentObj.fields.splice(i, 1);
                          prev.contentObj.content.splice(i, 1);
                          prev.contentObj.sortNo.splice(i, 1);
                          return { contentObj: prev.contentObj };
                        });
                      }}
                      onCancel={() => {}}
                      okText="Yes"
                      cancelText="No"
                    >
                      <span className="gx-link" title="Delete">
                        <i class="icon icon-trash"></i>
                      </span>
                    </Popconfirm>
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
    };

    render() {
        // Sort-Table-Scripts-Start
        let { contentObj } = this.state;

        let contentAll = [];
        for (let i = 0; i < contentObj.sortNo.length; i++) {
            contentAll.push({
                content: contentObj.content[i],
                sort: contentObj.sortNo[i],
                type: "html"
            })
        }
        ItemFormHelper.setContentState({
            content: contentAll
        });
        // AdState Setter End

        return (
            <Form>
                <div className="ant-row hd-title gx-m-0">
                    <div className="ant-col-md-12">
                        <h1>Manage Content</h1>
                    </div>
                    <div className="ant-col-md-12 rite-btn">
                        <Button
                            type="primary"
                            className="color-white"
                            onClick={() => {
                                this.setState((prev) => {
                                    prev.contentObj.fields.push("");
                                    return { contentObj: prev.contentObj };
                                });
                            }}
                        >
                            <i class="icon icon-add"></i> Add
                        </Button>
                    </div>
                </div>

                <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                        <div className="item-detail-edit-box">
                            {this.state.contentObj?.fields?.map((item, index) => {
                                return this._renderAd(index);
                            })}
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

export default ContentSection;